const deburrWord = (word) => {
  return word
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/-/g, '');
};

export const commonWordCheck = (word1, word2) => {
  if (word1 === word2) {
    return {
      equal: 'yes',
      word1,
      word2,
    };
  }
  const lowerWord1 = deburrWord(word1.toLowerCase().trim().replace(/\s/g, '+'));
  const lowerWord2 = deburrWord(word2.toLowerCase().trim().replace(/\s/g, '+'));

  if (lowerWord1?.length === 0 || lowerWord2?.length === 0) {
    return {
      equal: 'no',
      word1: lowerWord1,
      word2: lowerWord2,
    };
  }
  if (lowerWord1 === lowerWord2) {
    return {
      equal: 'yes',
      word1: lowerWord1,
      word2: lowerWord2,
    };
  }

  return {
    equal: 'unknown',
    word1: lowerWord1,
    word2: lowerWord2,
  };
};
